<template>
  <div class="popup fixed z-50">
    <div class="popup__inner fixed z-40 py-5 px-8 bg-white">
      <div class="popup__header text-NotoSansRegular text-gray-700 text-center">
      <span>提示訊息</span>
      </div>
      <div class="popup__body text-NotoSansRegular text-gray-700 text-center mb-8">
        確定要刪除?
      </div>
      <div class="popup__buttons flex justify-center">
        <a class="mx-2 py-3 rounded text-gray-700 btn btn--small popup__ok cursor-pointer hover:bg-gray-800 hover:text-white text-NotoSansRegular" @click="verify">
          確定
        </a>
        <a class="mx-2 py-3 rounded text-white btn btn--small popup__ok cursor-pointer bg-gray-800 hover:bg-gray-700 hover:text-white text-NotoSansRegular" @click="closePop">
          取消
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteConfirm',
  data () {
    return {
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    closePop () {
      this.$emit('closePop', false)
    },
    verify () {
      this.$emit('closePop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .popup__inner {
    top: 40%;
    left: 0;
    right: 0;
    width: 370px;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    .popup__header {
      margin-bottom: 15px;
      font-size: 0.85em;
      font-weight: bold;
      span {
        border-bottom: 1px solid #000;
      }
    }
    .popup__body {
      margin: 15px 0;
      font-size: 0.85em;
    }
  .popup__buttons {
    .btn--small {
        line-height: 22px;
    }
    .btn {
      display: inline-block;
      border: 0;
      font-size: 11px;
      text-align: center;
      text-decoration: none;
      vertical-align: middle;
      height: auto;
      padding: 0.5rem 1rem;
      line-height: 1;
      background-color: #fff;
      border: 1px solid #646565;
      white-space: nowrap;
      }
    }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}
</style>
